export let URL_GEOSERVER = {
    UrlGeoserver: 'http://localhost:8080/geoserver/41zre/wms',
    //UrlGeoserver: 'https://catalogacion.cusco.gob.pe:8080/geoserver/41zre/wms',
    UrlGeoserverOws: 'http://localhost:8080/geoserver/41zre/ows?',
    //UrlGeoserverOws: 'https://catalogacion.cusco.gob.pe:8080/geoserver/41zre/ows?'
}

export let URL_API = {
    UrlApi: 'https://catalogacion.cusco.gob.pe',
    UrlApiSisCatalogacion: 'https://catalogacion.cusco.gob.pe',
    UrlServidorPubico: 'https://catalogacion.cusco.gob.pe'
}

export let URL_WEB_SERVER ={
    UrlWebServer:'https://catalogacion.cusco.gob.pe'
}
